export default {
    home: 'Inicio',
    companies: 'Organizaciones',
    threats: 'Amenazas',
    assets: 'Activos',
    users: 'Usuarios',
    roles: 'Roles',
    myAccount: 'Mi cuenta',
    risksModule: 'Gestión de Riesgos',
    pentestingModule: 'Ciberdiagnóstico',
};
